import type { ReactNode } from 'react';
import { cn } from '../cn.js';
import { Icon } from './Icon.js';

export interface AppBarProps {
  title?: string;
  /** Show a back button and call this when pressed. */
  onBack?: () => void;
  /** Trailing action(s) rendered on the right. */
  trailing?: ReactNode;
  /** Large-title style (bigger, left-aligned). */
  large?: boolean;
  className?: string;
}

/** A sticky top app bar for a screen. */
export function AppBar({ title, onBack, trailing, large = false, className }: AppBarProps): JSX.Element {
  return (
    <header className={cn('as-appbar', large && 'as-appbar--large', className)}>
      <div className="as-appbar__side">
        {onBack && (
          <button type="button" className="as-appbar__back" aria-label="Back" onClick={onBack}>
            <Icon name="arrow-left" size={22} />
          </button>
        )}
      </div>
      {title && <h1 className="as-appbar__title">{title}</h1>}
      <div className="as-appbar__side as-appbar__side--end">{trailing}</div>
    </header>
  );
}
